import { ChangeRequest } from "./ChangeRequest";
import { Measurement } from "./Measurement";

export type FuelTransaction = {
    id: string;
    fuelCardIdentifier?: string;
    transactionDate: Date | string;
    licensePlate: string;
    fuelType: string;
    amountIncludingVAT: string | number;
    litersOfFuel: number;
    gasStationName?: string;
    withSubstituteCar?: boolean;
    city?: string;
    fuelConsumptionInKml?: string;
    kilometersTotal: Measurement;
    status?: FuelTransactionStatus;
    changeRequest?: ChangeRequest;
    isFromPreviousPeriod?: boolean;
};

export type AddFuelTransaction = Omit<FuelTransaction, 'id' | 'status' | 'changeRequest' | 'kilometersTotal' | 'licensePlate' | 'fuelType'>;

export type EditFuelTransaction = {
    id: string;
    kilometersTotal: number;
    remark?: string;
};

export enum ChangeRequestStatus {
    DEFAULT= -1,
    PENDING = 0,
    APPROVED = 1,
    REJECTED = 2,
}

export enum FuelTransactionStatus {
    DEFAULT= -1,
    PENDING = 0,
    APPROVED = 1,
    REJECTED = 2,
    INACCURATE = 3, // inconsistent kilometrage
    FUEL_CONSUMPTION_INCONSISTENT = 4
}
